const items = [
  {
    name: 'Mike Attea',
    title: 'Director of Property Management',
    company: 'Good Carbon Co.',
    testimonial:
      'Joblio really cares about reinvesting in wrap-around services for refugees so it’s truly a positive outcome for all.'
  },
  {
    name: 'Brian Tabaczynski',
    title: 'Operations Manager',
    company: 'Besroi Roofing & Siding',
    testimonial:
      'For any service industry, it’s a game-changer. Joblio will only partner with companies that are on the same moral and ethical compass as them. It’s a culture you want as a whole company.'
  },
  {
    name: 'Meghann Rumpf Perry',
    title: 'Senior Director, Community Services',
    company: 'Jewish Family Services of WNY',
    testimonial:
      'If Joblio is presented a challenge, they open doors because they have a lot of connections and see things in a different way.'
  },
  {
    name: 'Domenic Cortese',
    title: 'President',
    company: 'Cortese Construction Services',
    testimonial:
      'There’s now peace of mind that this service exists to help us.'
  },
  {
    name: 'Sean Greenhouse',
    title: 'COO',
    company: 'Linita Design & Manufacturing Corp.',
    testimonial: 'I see Joblio as being a big part of our growth.'
  },
  {
    name: 'Bob Karmazyn',
    title: 'General Manager',
    company: 'Embassy Suites by Hilton Buffalo',
    testimonial:
      'Joblio brings individuals to our business who want to work and be here. That’s been the biggest advantage.'
  },
  {
    name: 'Don Smith',
    title: 'Comptroller',
    company: 'Perma Tech',
    testimonial:
      'The quality of the individual has far exceeded the quality of any other individual we hired in the last year or two. Right off the bat, he became a rockstar.'
  },
  {
    name: 'Shawn Thompson',
    title: 'Vice President of Operations',
    company: 'McGard',
    testimonial:
      'I was skeptical and cautious at first, but the wrap-around services they provide show me it’s not a temporary job or a passing position. They’re in it for the long haul.'
  },
  {
    name: 'Larry Tobin',
    title: 'Director',
    company: 'The Shapiro Foundation',
    testimonial:
      'Joblio is a perfect broker between employers and displaced talent. It is rare to find an entity which can bridge that divide.'
  },
  {
    name: 'Lori Procher',
    title: 'Chief People Officer',
    company: 'FGF Brands',
    testimonial:
      'I highly recommend Joblio to any organization seeking to build a diverse, loyal and vibrant team.'
  },
  {
    name: 'David Arkless',
    title: 'Non-Executive Chairman of Joblio Advisory Board',
    company: 'Former President at ManpowerGroup',
    testimonial:
      'Joblio, in my opinion, offers something that nobody else is offering. It’s the perfect conjunction of putting people to work and doing the right thing.'
  }
];

export default items;
